import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoIosAdd, IoIosArrowBack } from "react-icons/io";
import {
  Box,
  Grid,
  Typography,
  MenuItem,
  TextField,
  Checkbox,
} from "@mui/material";
import styles from "../../screens2/Candidates/Candidate.module.css";
import { customTextColor, whichFile } from "../../utils/const";
import { CiMobile3 } from "react-icons/ci";
import {
  PiBuildingOfficeLight,
  PiMailboxLight,
  PiMapPinSimpleLineLight,
} from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiNewspaperClippingLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { PiUserLight } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { PiMapPinSimpleAreaLight } from "react-icons/pi";
import React, { useCallback, useEffect, useState } from "react";
import {
  addLocationDirect,
  allLocation,
  getAllCountry,
  getAllState,
} from "../../redux/common/locationSlice";
import {
  addWorkAuthorization,
  allWorkAuthorization,
} from "../../redux/common/workAuthorizationSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { resumeProcces } from "../../redux/internal-tracking/InternalTrackerSlice";
import { addSkill, allSkill } from "../../redux/common/skillSlice";
import { IoIosArrowRoundBack } from "react-icons/io";
import { addEducationSkill } from "../../redux/InternalStatic/internalCandidateStatic";
import { CiLinkedin } from "react-icons/ci";
import { PiBuildingsLight } from "react-icons/pi";
import { PiBookOpenUserLight } from "react-icons/pi";
import { PiInvoiceLight } from "react-icons/pi";
import { resetAddedSkill } from "../../redux/common/skillSlice";
import { getProfile } from "../../redux/profile/profileSlice";
import {
  checkCandidateExist,
  createCandidateProfile,
  createExistCandidateProfile,
  getAllCandidate,
  getBenchsalesByMail,
  getOneCandidate,
  updateExistCandidateProfile,
} from "../../redux/candidate/candidateSlice";
import { IoBookOutline } from "react-icons/io5";
import { FixedSizeList } from "react-window";

const work = [
  { value: "Onsite", label: "Onsite" },
  { value: "Hybrid", label: "Hybrid" },
  { value: "Remote", label: "Remote" },
  { value: "All", label: "All" },
];

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const fieldStyle1 = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
  pointerEvents: "none",
  cursor: "not-allowed",
};

const prefer_tax_term_bench = [
  { id: "contract", name: "Contract" },
  { id: "contract_to_hire", name: "Contract To Hire" },
  { id: "full_Time", name: "Fulltime" },
  { id: "w2_with_benefit", name: "W2 Hourly Benefit" },
  { id: "w2_without_benefit", name: "W2 Hourly No Benefit" },
  { id: "1099", name: "1099" },
];

const renderVirtualizedList = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} {...rest}>
      <FixedSizeList
        height={300} // Adjust dropdown height
        width="100%"
        itemSize={46} // Height of each item
        itemCount={children.length}
      >
        {({ index, style }) =>
          React.cloneElement(children[index], {
            style: { ...style, top: `${style.top}px` },
            onMouseDown: (event) => {
              // Prevent closing on click
              event.preventDefault();
            },
          })
        }
      </FixedSizeList>
    </div>
  );
});

const AddCandidateDrawer = ({ handleClose, show, row, candidateType }) => {
  const [skilldata, setSkilldata] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [primarySkillIds, setPrimarySkillIds] = useState([]);
  const [secondarySkillIds, setSecondarySkillIds] = useState([]);
  const [whichAdd, setWhichAdd] = useState("");
  const [inputText, setInputText] = useState("");
  const [inputTextSecondary, setInputTextSecondary] = useState("");
  const [isEnter, setIsEnter] = useState(false);
  const location = useLocation();
  const [formFields, setFormFields] = useState([
    {
      role: "",
      company: "",
      industry_of_the_company: "",
      duration_from: "",
      duration_to: "",
      summary_of_work: "",
    },
  ]);
  const { prevData1 } = location.state || {};

  ///////////////////////////////////////////////////////////

  const [selectedFileName, setSelectedFileName] = useState("");
  const [base64Resume, setBase64Resume] = useState();

  const [resumeError, setResumeError] = useState(false);

  const [locationIds, setLocationIds] = useState([]);
  const [workAuthorizeIds, setWorkAuthorizeIds] = useState([]);
  const resumeData = useSelector((state) => state.tracker.resumeData);
  const skillData = useSelector((state) => state.skill.data);
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const stateData = useSelector((state) => state.location?.stateData);
  const profile = useSelector((state) => state.profile.data);
  const searchData = useSelector((state) => state.candidate.searchData);
  const candidateStatus = useSelector((state) => state.candidate.status);
  const addedSkill = useSelector((state) => state.skill.addedSkill);
  const educationData = useSelector(
    (state) => state.internalCandidateStatic.educationData
  );
  const benchsalesData = useSelector((state) => state.candidate.benchsalesData);
  const { returnSelectedFileName } = location.state || {};

  const formik = useFormik({
    initialValues: {
      full_name: row?.full_name || "",
      current_job_title: row?.current_job_title || "",
      total_experience: row?.total_experience || "",
      current_location: row?.current_location || "",
      work_authorization: row?.work_authorization || "",
      prefer_tax_team: row?.prefer_tax_team || [],
      mobile_no: row?.mobile_no || "",
      alternative_mobile_no: row?.alternative_mobile_no || "",
      email: row?.email || "",
      prefer_location: row?.prefer_location || [],
      resume: "",
      rate: row?.rate || "",
      highest_qualification: row?.highest_qualification || "",
      university: row?.university || "",
      linkedin_profile_url: row?.linkedin_profile_url || "",
      passing_year: row?.passing_year || "",
      work_preference: row?.work_preference || "",
      selectedFileName: null,
      skills: row?.skills || [],
      secondary_skills: row?.secondary_skills || [],
      previous_experience: null,
      referrer_company_name: row?.referrer_company_name || "",
      referrer_mobile_no: row?.referrer_mobile_no || "",
      referrer_manager_name: row?.referrer_manager_name || "",
      referrer_manager_name2: row?.referrer_manager_name2 || "",
      referrer_company_name2: row?.referrer_company_name2 || "",
      referrer_email2: row?.referrer_email2 || "",
      referrer_mobile_no2: row?.referrer_mobile_no2 || "",
      referrer_email: row?.referrer_email || "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      current_job_title: Yup.string().required("Job Title is required"),
      total_experience: Yup.string().required("Experience is required"),
      current_location: Yup.string().required("Current Location is required"),
      work_authorization: Yup.string().required(
        "Work Authorization is required"
      ),
      prefer_tax_team: Yup.array()
        .of(Yup.string())
        .min(1, "Prefer Tax term is required")
        .required("Prefer Tax term is required"),
      // prefer_tax_team: Yup.string().test(
      //   "is-valid-array",
      //   "Prefer Tax term is required",
      //   (value) => {
      //     try {
      //       const arr = JSON.parse(value);
      //       return Array.isArray(arr) && arr.length >= 1;
      //     } catch {
      //       return false;
      //     }
      //   }
      // ),

      mobile_no: Yup.string().required("Mobile Number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      prefer_location: Yup.array()
        .of(Yup.string())
        .min(1, "Prefer Location is required")
        .required("Prefer Location is required"),
      highest_qualification: Yup.string().required(
        "Highest Qualification is required"
      ),
      university: Yup.string().required("University is required"),
      passing_year: Yup.string().required("Passing Year is required"),
      rate: Yup.string().required("Rate is required"),
      work_preference: Yup.string().required("Work Preference is required"),
      alternative_mobile_no: Yup.string()
      .matches(/^[\d\s.\-()+]*$/, "Invalid characters in phone number")
      .test(
        'valid-10-digit',
        'Phone number must be exactly 10 digits',
        (value) => {
          if (!value) return true; // Not required
          const digitsOnly = value.replace(/\D/g, ''); // Remove all non-digit chars
          return digitsOnly.length === 10;
        }
      ),

      // referrer_manager_name2: Yup.string().when(
      //   "prefer_tax_team",
      //   ([prefer_tax_team = []], schema) =>
      //     prefer_tax_team.includes("contract")
      //       ? schema.required("Referrer Manager Name2 is required")
      //       : schema.notRequired()
      // ),

      // referrer_company_name2: Yup.string().when(
      //   "prefer_tax_team",
      //   ([prefer_tax_team = []], schema) =>
      //     prefer_tax_team.includes("contract")
      //       ? schema.required("Referrer Company Name2 is required")
      //       : schema.notRequired()
      // ),

      // referrer_email2: Yup.string().when(
      //   "prefer_tax_team",
      //   ([prefer_tax_team = []], schema) =>
      //     prefer_tax_team.includes("contract")
      //       ? schema
      //           .email("Invalid email address")
      //           .required("Referrer Email2 is required")
      //       : schema.notRequired()
      // ),

      // referrer_mobile_no2: Yup.string().when(
      //   "prefer_tax_team",
      //   ([prefer_tax_team = []], schema) =>
      //     prefer_tax_team.includes("contract")
      //       ? schema.required("Referrer Mobile No2 is required")
      //       : schema.notRequired()
      // ),

      referrer_manager_name2: Yup.string().when(
        "prefer_tax_team",
        ([prefer_tax_team = []], schema) =>
          prefer_tax_team.includes("contract") ||
          prefer_tax_team.includes("contract_to_hire")
            ? schema.required("Employer’s Name is required")
            : schema.notRequired()
      ),

      referrer_company_name2: Yup.string().when(
        "prefer_tax_team",
        ([prefer_tax_team = []], schema) =>
          prefer_tax_team.includes("contract") ||
          prefer_tax_team.includes("contract_to_hire")
            ? schema.required("Company Name is required")
            : schema.notRequired()
      ),

      referrer_email2: Yup.string().when(
        "prefer_tax_team",
        ([prefer_tax_team = []], schema) =>
          prefer_tax_team.includes("contract") ||
          prefer_tax_team.includes("contract_to_hire")
            ? schema
                .email("Invalid email address")
                .required("Email ID is required")
            : schema.notRequired()
      ),

      referrer_mobile_no2: Yup.string().when(
        "prefer_tax_team",
        ([prefer_tax_team = []], schema) =>
          prefer_tax_team.includes("contract") ||
          prefer_tax_team.includes("contract_to_hire")
            ? schema.required("Phone No is required")
            : schema.notRequired()
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      handleOnSubmitTracker();
    },
  });

  useEffect(() => {
    dispatch(addEducationSkill(resumeData?.data?.processed_json));
    if (resumeData && selectedFileName !== "") {
      formik.setFieldValue(
        "full_name",
        resumeData?.data?.processed_json?.name || ""
      );
      formik.setFieldValue(
        "total_experience",
        resumeData?.data?.processed_json?.total_experience || ""
      );
      formik.setFieldValue(
        "mobile_no",
        resumeData?.data?.processed_json?.phone || ""
      );
      formik.setFieldValue(
        "email",
        resumeData?.data?.processed_json?.email || ""
      );
      formik.setFieldValue(
        "linkedin_profile_url",
        resumeData?.data?.processed_json?.linkedin_profile_url || ""
      );

      formik.setFieldValue(
        "current_job_title",
        resumeData?.data?.processed_json?.job_profile || ""
      );

      formik.setFieldValue(
        "alternative_mobile_no",
        resumeData?.data?.processed_json?.alternate_contact || ""
      );

      formik.setFieldValue(
        "passing_year",
        resumeData?.data?.processed_json?.passing_year || ""
      );
      formik.setFieldValue(
        "highest_qualification",
        resumeData?.data?.processed_json?.highest_qualification || ""
      );
      formik.setFieldValue(
        "university",
        resumeData?.data?.processed_json?.university || ""
      );
      setFormFields(resumeData?.data?.processed_json?.companies);
    }
  }, [resumeData]);

  useEffect(() => {
    if (Object.keys(row).length > 0) {
      formik.setFieldValue("full_name", row?.full_name || "");
      formik.setFieldValue("total_experience", row?.total_experience || "");
      formik.setFieldValue("mobile_no", row?.mobile_no || "");
      formik.setFieldValue("email", row?.email || "");
      formik.setFieldValue(
        "linkedin_profile_url",
        row?.linkedin_profile_url || ""
      );

      formik.setFieldValue("current_job_title", row?.current_job_title || "");

      formik.setFieldValue(
        "alternative_mobile_no",
        row?.alternative_mobile_no || ""
      );

      formik.setFieldValue("passing_year", row?.passing_year || "");
      formik.setFieldValue(
        "highest_qualification",
        row?.highest_qualification || ""
      );
      formik.setFieldValue("current_location", row?.current_location || "");
      formik.setFieldValue("work_authorization", row?.work_authorization || "");
      formik.setFieldValue("prefer_location", row?.prefer_location || "");
      formik.setFieldValue(
        "secondary_skills",
        JSON.parse(row?.secondary_skills) || ""
      );
      formik.setFieldValue("skills", row?.skills || "");
      formik.setFieldValue("rate", row?.rate || "");
      formik.setFieldValue("university", row?.university || "");
      formik.setFieldValue("work_preference", row?.work_preference || "");
      formik.setFieldValue(
        "prefer_tax_team",
        Array.isArray(row?.p_tax_team)
          ? row?.p_tax_team
          : JSON.parse(row?.p_tax_team) || []
      );
      formik.setFieldValue(
        "referrer_company_name",
        row?.referrer_company_name || ""
      );
      formik.setFieldValue("referrer_mobile_no", row?.referrer_mobile_no || "");
      formik.setFieldValue(
        "referrer_manager_name",
        row?.referrer_manager_name || ""
      );
      formik.setFieldValue(
        "referrer_manager_name2",
        row?.referrer_manager_name2 || ""
      );
      formik.setFieldValue(
        "referrer_company_name2",
        row?.referrer_company_name2 || ""
      );
      formik.setFieldValue("referrer_email2", row?.referrer_email2 || "");
      formik.setFieldValue(
        "referrer_mobile_no2",
        row?.referrer_mobile_no2 || ""
      );
      formik.setFieldValue("referrer_email", row?.referrer_email || "");

      setFormFields(JSON.parse(row?.previous_experience) || null);
    }
  }, [row]);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(getAllCountry());
    dispatch(getAllState());
  }, []);

  useEffect(() => {
    formik.setFieldValue("selectedFileName", selectedFileName || "");
  }, [selectedFileName]);

  useEffect(() => {
    if (!resumeData || !locations) return;
    const checkAndAddLocation = async (locations, resumeData) => {
      const allLocation = locations?.data?.locations || [];
      const current_country = resumeData?.data?.processed_json?.current_country;

      const current_state = resumeData?.data?.processed_json?.current_state;

      const currentLocation =
        resumeData?.data?.processed_json?.current_location;

      if (!currentLocation) {
        // console.error("Current location is not provided in resumeData.");
        return null;
      }

      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation?.toLowerCase()
      );

      if (existingLocation) {
        return existingLocation.id;
      } else {
        try {
          const newLocation = await dispatch(
            addLocationDirect({
              location_name: currentLocation,
              country_name: current_country,
              state_name: current_state,
            })
          );
          return newLocation?.payload?.location?.id || null;
        } catch (error) {
          // console.error("Failed to add location:", error);
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(locations, resumeData);
      setLocationIds(locationId);
    })();
  }, [resumeData]);

  // useEffect(() => {
  //   if (!resumeData || !locations || !stateData) return;

  //   const checkAndAddLocation = async (resumeData, locations, stateData) => {
  //     const currentLocation =
  //       resumeData?.data?.processed_json?.current_location;
  //     const currentState = resumeData?.data?.processed_json?.current_state;

  //     if (!currentState || !currentLocation) {
  //       console.error(
  //         "Missing current_state or current_location in resumeData."
  //       );
  //       return null;
  //     }

  //     // Normalize for comparison
  //     const normalize = (str) => str?.toLowerCase().trim();

  //     // 1. Check or Add State
  //     let stateEntry = stateData?.states?.find(
  //       (state) => normalize(state.name) === normalize(currentState)
  //     );

  //     let stateId;
  //     if (stateEntry) {
  //       stateId = stateEntry.id;
  //     } else {
  //       try {
  //         const newState = await dispatch(
  //           createState({ name: currentState, country: 1 })
  //         );
  //         stateId = newState?.id;
  //         if (!stateId) throw new Error("No state ID returned after creation.");
  //       } catch (err) {
  //         console.error("Failed to add state:", err);
  //         return null;
  //       }
  //     }

  //     // 2. Check or Add Location
  //     const allLocations = locations?.data?.locations || [];
  //     const existingLocation = allLocations.find(
  //       (location) =>
  //         normalize(location.name) === normalize(currentLocation) &&
  //         location.state === stateId
  //     );

  //     if (existingLocation) {
  //       return existingLocation.id;
  //     } else {
  //       try {
  //         const newLocation = await dispatch(
  //           addLocation({ name: currentLocation, state: stateId })
  //         );
  //         const locationId = newLocation?.id;
  //         if (!locationId)
  //           throw new Error("No location ID returned after creation.");
  //         return locationId;
  //       } catch (error) {
  //         console.error("Failed to add location:", error);
  //         return null;
  //       }
  //     }
  //   };

  //   (async () => {
  //     const locationId = await checkAndAddLocation(
  //       resumeData,
  //       locations,
  //       stateData
  //     );
  //     setLocationIds(locationId);
  //   })();
  // }, [resumeData, locations, stateData]);

  // ....................................................................................

  // const hasProcessedRef = useRef(false);

  // useEffect(() => {
  //   if (!resumeData || !locations || !stateData) return;
  //   if (hasProcessedRef.current) return;

  //   const checkAndAddLocation = async () => {
  //     const currentLocation =
  //       resumeData?.data?.processed_json?.current_location;
  //     const currentState = resumeData?.data?.processed_json?.current_state;

  //     if (!currentState || !currentLocation) {
  //       console.error(
  //         "Missing current_state or current_location in resumeData."
  //       );
  //       return null;
  //     }

  //     const normalize = (str) => str?.toLowerCase().trim();

  //     // 1. Check or Add State
  //     let stateEntry = stateData?.states?.find(
  //       (state) => normalize(state.name) === normalize(currentState)
  //     );
  //     let stateId;
  //     if (stateEntry) {
  //       stateId = stateEntry.id;
  //     } else {
  //       try {
  //         const response = await dispatch(
  //           createState({ name: currentState, country: 1 })
  //         );

  //         const newState = response?.payload;
  //         stateId = newState?.id;
  //         if (!stateId) {
  //           console.error("No state ID returned after state creation");
  //           return null;
  //         }
  //       } catch (err) {
  //         console.error("Failed to create state:", err);
  //         return null;
  //       }
  //     }

  //     // 2. Check or Add Location
  //     const allLocations = locations?.data?.locations || [];
  //     const existingLocation = allLocations.find(
  //       (location) =>
  //         normalize(location.name) === normalize(currentLocation) &&
  //         location.state === stateId
  //     );

  //     if (existingLocation) {
  //       return existingLocation.id;
  //     } else {
  //       try {
  //         const response = await dispatch(
  //           addLocation({ name: currentLocation, state: stateId })
  //         );

  //         const newLocation = response?.payload;
  //         const locationId = newLocation?.id;
  //         if (!locationId) {
  //           console.error("No location ID returned after location creation");
  //           return null;
  //         }
  //         return locationId;
  //       } catch (error) {
  //         console.error("Failed to add location:", error);
  //         return null;
  //       }
  //     }
  //   };

  //   (async () => {
  //     const locationId = await checkAndAddLocation();
  //     hasProcessedRef.current = true;
  //     setLocationIds(locationId);
  //   })();
  // }, [resumeData, locations, stateData]);

  // ....................................................................................

  useEffect(() => {
    if (!resumeData || !workautho) return;
    const checkAndAddLocation = async (workautho, resumeData) => {
      const allLocation = workautho?.data?.work_authorization_data || "";
      const currentLocation =
        resumeData?.data?.processed_json?.work_authorization;

      if (!currentLocation) {
        // console.error("Current location is not provided in resumeData.");
        return null;
      }

      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation?.toLowerCase()
      );

      if (existingLocation) {
        return existingLocation.id;
      } else {
        try {
          const newLocation = await dispatch(
            addWorkAuthorization({ name: currentLocation })
          );
          return newLocation?.id || null;
        } catch (error) {
          // console.error("Failed to add location:", error);
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(workautho, resumeData);
      setWorkAuthorizeIds(locationId);
    })();
  }, [resumeData]);

  // useEffect(() => {
  //   if (row) {
  //     setWorkAuthorizeIds(row?.work_authorization);
  //     setLocationIds(row?.current_location);
  //   }
  // }, [row]);
  useEffect(() => {
    if (locationIds) {
      formik.setFieldValue("current_location", locationIds);
    }
  }, [locationIds]);

  useEffect(() => {
    if (workAuthorizeIds) {
      formik.setFieldValue("work_authorization", workAuthorizeIds);
    }
  }, [workAuthorizeIds]);

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("full_name", value);
    }
  };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  const handleAlternativeMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("alternative_mobile_no", value);
    }
  };

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        const formattedBase64 = `data:${whichFile(
          fileExtension
        )};base64,${base64String}`;

        setBase64Resume(formattedBase64);

        // Set file name and prepare form data
        setSelectedFileName(file.name);
        const formData = new FormData();
        formData.append("resume_file", file);
        dispatch(resumeProcces(formData));
      };

      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setSelectedFileName(returnSelectedFileName);
  }, [returnSelectedFileName]);

  ////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (skillData?.locations?.length > 0) {
      setSkilldata(skillData);
    }
  }, [skillData]);

  const mapSkillsToIds = (skillsList, allSkillsMap) => {
    const skillIds = [];
    const missingSkills = [];
    skillsList?.forEach((skill) => {
      const skillLower = skill.toLowerCase();
      if (allSkillsMap[skillLower]) {
        skillIds?.push(allSkillsMap[skillLower]);
      } else {
        missingSkills?.push(skill);
      }
    });

    return { skillIds, missingSkills };
  };

  useEffect(() => {
    if (primarySkillIds?.length > 0) {
      formik.setFieldValue("skills", primarySkillIds || []);
    }
  }, [primarySkillIds]);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    formik.setFieldValue("previous_experience", formFields || "");
  }, [formFields]);

  const handleAddFields = () => {
    setFormFields([
      ...formFields,
      {
        role: "",
        company: "",
        industry_of_the_company: "",
        duration_to: "",
        duration_from: "",
        summary_of_work: "",
      },
    ]);
  };

  const handleInputChange = (index, event) => {
    const values = [...formFields];
    values[index][event.target.name] = event.target.value;
    setFormFields(values);
  };
  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  useEffect(() => {
    if (
      prevData1?.secondary_skills === undefined ||
      prevData1?.secondary_skills === null ||
      prevData1?.secondary_skills === ""
    ) {
      if (secondarySkillIds?.length > 0) {
        formik.setFieldValue("secondary_skills", secondarySkillIds || []);
      }
    }
  }, [secondarySkillIds, prevData1]);

  useEffect(() => {
    dispatch(allSkill());
  }, []);

  useEffect(() => {
    if (!educationData || !skillData) return;
    if (isEnter === false) {
      const allSkillsMap = skillData?.locations?.reduce((acc, skill) => {
        acc[skill?.name?.toLowerCase()] = skill?.id;
        return acc;
      }, {});

      const primary = mapSkillsToIds(
        educationData?.skills?.primary_skills || [],
        allSkillsMap
      );
      const secondary = mapSkillsToIds(
        educationData?.skills?.secondary_skills || [],
        allSkillsMap
      );

      setPrimarySkillIds(primary?.skillIds);
      // setMissingPrimarySkills(primary?.missingSkills);
      setSecondarySkillIds(secondary?.skillIds);
      // setMissingSecondarySkills(secondary?.missingSkills);

      const missingSkills = [
        ...primary?.missingSkills,
        ...secondary?.missingSkills,
      ];
      if (missingSkills?.length > 0) {
        Promise.all(
          missingSkills?.map((skill) => dispatch(addSkill({ name: skill })))
        )
          .then(async () => {
            // Step 4: Fetch updated skills after all new skills are added
            const updatedSkills = await dispatch(allSkill()).unwrap();
            const updatedSkillsMap = updatedSkills?.reduce((acc, skill) => {
              acc[skill?.name.toLowerCase()] = skill?.id;
              return acc;
            }, {});

            // Step 5: Remap primary and secondary skills to IDs
            const updatedPrimary = mapSkillsToIds(
              educationData.primary_skills || [],
              updatedSkillsMap
            );
            const updatedSecondary = mapSkillsToIds(
              educationData.secondary_skills || [],
              updatedSkillsMap
            );

            setPrimarySkillIds(updatedPrimary?.skillIds);
            setSecondarySkillIds(updatedSecondary?.skillIds);
          })
          .catch((error) => {
            // console.error("Error adding skills:", error);
          });
      }
    }
  }, [educationData, skillData, dispatch]);

  useEffect(() => {
    if (primarySkillIds?.length > 0) {
      formik.setFieldValue("skills", primarySkillIds || []);
    }
  }, [primarySkillIds]);

  useEffect(() => {
    if (addedSkill?.location?.id) {
      const skillId = addedSkill?.location?.id;
      const currentSkills = formik.values.skills || [];
      const currentSecondarySkill = formik.values.secondary_skills || [];

      if (!currentSkills.includes(skillId) && whichAdd === "first") {
        formik.setFieldValue("skills", [...currentSkills, skillId]);
        setInputText("");
        dispatch(resetAddedSkill());
      }

      if (!currentSecondarySkill.includes(skillId) && whichAdd === "second") {
        formik.setFieldValue("secondary_skills", [
          ...currentSecondarySkill,
          skillId,
        ]);
        setInputTextSecondary("");
        dispatch(resetAddedSkill());
      }
    }
  }, [addedSkill, formik, dispatch, whichAdd]);

  const handleAddSkill = useCallback(async () => {
    if (inputText.trim()) {
      const newSkill = inputText.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        setWhichAdd("first");
        setIsEnter(true);
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh skills
      }
    }
  }, [inputText, skillData, dispatch]);

  const handleAddSkillSecondary = useCallback(async () => {
    if (inputTextSecondary.trim()) {
      const newSkill = inputTextSecondary.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        setWhichAdd("second");
        setIsEnter(true);
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh skills
      }
    }
  }, [inputTextSecondary, skillData, dispatch]);

  const handleClearAll = () => {
    formik.setFieldValue("skills", []); // Clear Formik field
    setInputText(""); // Clear input text

    // ✅ Reset addedSkill to prevent it from reappearing
    dispatch(resetAddedSkill());
  };

  const handleClearAllSecondarySkill = () => {
    formik.setFieldValue("secondary_skills", []); // Clear Formik field
    setInputTextSecondary(""); // Clear input text

    // ✅ Reset addedSkill to prevent it from reappearing
    dispatch(resetAddedSkill());
  };

  //////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    let mobile_no = formik?.values?.mobile_no?.replace(/[^0-9]/g, "");
    let email = formik?.values?.email;

    dispatch(checkCandidateExist({ email, mobile_no }));
  }, [formik?.values?.mobile_no, formik?.values?.email]);

  let userData = {
    email: formik?.values?.email,
    mobile_no: parseInt(formik?.values?.mobile_no?.replace(/[^0-9]/g, ""), 10),
    alternative_mobile_no: formik?.values?.alternative_mobile_no?.replace(
      /[^0-9]/g,
      ""
    ),
    full_name: formik?.values?.full_name,
    gender: "Male",
    current_job_title: formik?.values?.current_job_title,
    total_experience: Number(formik?.values?.total_experience),
    current_location: formik?.values?.current_location,
    prefer_location: formik?.values?.prefer_location,
    work_authorization: `${formik?.values?.work_authorization}`,
    prefer_tax_team: "full_Time",
    p_tax_team: formik?.values?.prefer_tax_team,
    work_preference: formik?.values?.work_preference,
    previous_experience: JSON.stringify(formik?.values?.previous_experience),
    rate: Number(formik?.values?.rate),
    linkedin_profile_url: formik?.values?.linkedin_profile_url,
    resume: formik?.values?.resume,
    current_company: formik?.values?.current_company,
    passing_year: formik?.values?.passing_year,
    passing_year: `${formik?.values?.passing_year}`,
    highest_qualification: formik?.values?.highest_qualification,
    university: formik?.values?.university,
    skills: formik?.values?.skills,
    secondary_skills: JSON.stringify(formik?.values?.secondary_skills),
    referrer_company_name: formik?.values?.referrer_company_name,
    referrer_mobile_no: formik?.values?.referrer_mobile_no,
    referrer_manager_name: formik?.values?.referrer_manager_name,
    referrer_email: formik?.values?.referrer_email,
    referrer_manager_name2: formik?.values?.referrer_manager_name2,
    referrer_company_name2: formik?.values?.referrer_company_name2,
    referrer_email2: formik?.values?.referrer_email2,
    referrer_mobile_no2: formik?.values?.referrer_mobile_no2,
    role: "CANDIDATE",
    it_recruiter_user_id: profile?.profile?.user_id,
    candidate: searchData?.candidate_id,
    resume_profile_id: row?.id,
  };

  const handleOnSubmitTracker = () => {
    if (candidateType === "edit") {
      let jobId = row?.id;
      const { resume, ...values } = userData;
      dispatch(updateExistCandidateProfile({ values, jobId }));
    } else {
      if (searchData?.exist) {
        dispatch(createExistCandidateProfile(userData));
      } else {
        dispatch(createCandidateProfile(userData));
      }
    }
  };

  useEffect(() => {
    if (
      candidateStatus === "create_candidate_profile" ||
      candidateStatus === "create_candidate_exist_profile"
    ) {
      formik.resetForm();
      setFormFields([
        {
          role: "",
          company: "",
          industry_of_the_company: "",
          duration_from: "",
          duration_to: "",
          summary_of_work: "",
        },
      ]);
      setSelectedFileName("");
      setSecondarySkillIds([]);
      setPrimarySkillIds([]);
      dispatch(getAllCandidate());
      handleClose();
      if (row) {
        let ID = row?.id;
        dispatch(getOneCandidate(ID));
      }
    }
  }, [candidateStatus, row]);

  useEffect(() => {
    if (profile !== null) {
      formik.setFieldValue("it_recruiter_user_id", profile?.profile?.user_id);
    }
  }, [profile]);

  useEffect(() => {
    if (base64Resume) {
      formik.setFieldValue("resume", base64Resume || null);
    }
    setResumeError(false);
  }, [base64Resume]);

  useEffect(() => {
    if (formik?.values?.referrer_email) {
      let email = formik?.values?.referrer_email;
      dispatch(getBenchsalesByMail(email));
    }
  }, [formik?.values?.referrer_email]);

  const handleCloseDrawer = () => {
    formik.resetForm();
    handleClose();
  };

  const handleEmployerMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("referrer_mobile_no2", value);
    }
  };

  const handleEmployerFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("referrer_manager_name2", value);
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "60%",
        padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <IoIosArrowBack
            style={{
              fontSize: "22px",
              cursor: "pointer",
              color: customTextColor,
            }}
            onClick={handleCloseDrawer}
          />
          <span style={{ marginLeft: "15px" }}>
            <Typography> Get leverage credit on every profile view</Typography>
            <Typography>No Limitation of candidate list</Typography>
          </span>
        </span>
        <span style={{ textAlign: "right" }}>
          {candidateType !== "edit" && (
            <div>
              <button
                onClick={handleButtonClick}
                disabled={candidateStatus === "loading"}
                style={
                  candidateStatus === "loading"
                    ? {
                        padding: "7px 40px",
                        border: "none",
                        borderRadius: "3px",
                        backgroundColor: "#3856a6",
                        color: "#fff",
                        width: "auto",
                        padding: "7px 20px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }
                    : {
                        border: "none",
                        borderRadius: "3px",
                        backgroundColor: "#3856a6",
                        color: "#fff",
                        width: "auto",
                        padding: "7px 20px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }
                }
              >
                {candidateStatus === "loading" ? "Loading" : "Upload Resume"}
              </button>
              <input
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {selectedFileName && (
                <p
                  style={{
                    marginTop: "6px",
                    fontSize: "14px",
                    color: "#1b89de",
                  }}
                >
                  Selected file: {selectedFileName}
                </p>
              )}
              {resumeError === true ? (
                <div className={styles.error}>upload resume is required</div>
              ) : null}
            </div>
          )}
        </span>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box>
          <form onSubmit={formik.handleSubmit}>
            <Grid container className={styles.candidate_field_section}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiUserLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Candidate Name"
                  variant="standard"
                  name="full_name"
                  onChange={handleFullNameChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.full_name}
                  sx={
                    resumeData?.data?.processed_json?.name
                      ? fieldStyle1
                      : fieldStyle
                  }
                  disabled={candidateType === "edit"}
                />
                {formik.touched.full_name && formik.errors.full_name ? (
                  <div className={styles.error}>{formik.errors.full_name}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiMobile3 style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Contact No"
                  variant="standard"
                  type="text"
                  sx={
                    resumeData?.data?.processed_json?.phone
                      ? fieldStyle1
                      : fieldStyle
                  }
                  name="mobile_no"
                  onChange={handleMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile_no}
                  disabled={candidateType === "edit"}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no ? (
                  <div className={styles.error}>{formik.errors.mobile_no}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiMobile3 style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Alternative Contact No (Optional)"
                  variant="standard"
                  type="text"
                  name="alternative_mobile_no"
                  onChange={handleAlternativeMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.alternative_mobile_no}
                  sx={fieldStyle}
                />
                {formik.touched.alternative_mobile_no &&
                formik.errors.alternative_mobile_no ? (
                  <div className={styles.error}>
                    {formik.errors.alternative_mobile_no}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMailboxLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="E-Mail ID"
                  variant="standard"
                  type="text"
                  sx={
                    resumeData?.data?.processed_json?.email
                      ? fieldStyle1
                      : fieldStyle
                  }
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  disabled={candidateType === "edit"}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className={styles.error}>{formik.errors.email}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiChairLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Current Job Profile"
                  variant="standard"
                  type="text"
                  sx={fieldStyle}
                  name="current_job_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.current_job_title}
                />
                {formik.touched.current_job_title &&
                formik.errors.current_job_title ? (
                  <div className={styles.error}>
                    {formik.errors.current_job_title}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiAddressBookLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Total Experience "
                  variant="standard"
                  type="text"
                  sx={fieldStyle}
                  name="total_experience"
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                    formik.setFieldValue("total_experience", rawValue);
                  }}
                  // onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={
                    formik.values.total_experience
                      ? `${formik.values.total_experience} ${
                          formik.values.total_experience > 1 ? "Years" : "Year"
                        }`
                      : ""
                  }
                  // value={formik.values.total_experience}
                />
                {formik.touched.total_experience &&
                formik.errors.total_experience ? (
                  <div className={styles.error}>
                    {formik.errors.total_experience}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiIdentificationCardLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  select
                  label="Work Authorization"
                  variant="standard"
                  name="work_authorization"
                  sx={fieldStyle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_authorization}
                >
                  {workautho?.data?.work_authorization_data?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_authorization &&
                formik.errors.work_authorization ? (
                  <div className={styles.error}>
                    {formik.errors.work_authorization}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>

                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={prefer_tax_term_bench || []}
                  disableCloseOnSelect
                  value={
                    prefer_tax_term_bench?.filter((tax_term) =>
                      formik.values.prefer_tax_team?.includes(tax_term.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedPrefertaxterm = value?.map(
                      (tax_term) => tax_term?.id
                    );
                    formik.setFieldValue(
                      "prefer_tax_team",
                      selectedPrefertaxterm
                    );
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Prefer Tax Term"
                      variant="standard"
                      size="small"
                      name="prefer_tax_team"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />

                {formik.touched.prefer_tax_team &&
                formik.errors.prefer_tax_team ? (
                  <div className={styles.error}>
                    {formik.errors.prefer_tax_team}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  label="Currecnt Locations "
                  variant="standard"
                  select
                  sx={fieldStyle}
                  name="current_location"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.current_location}
                >
                  {locations?.data?.locations?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.current_location &&
                formik.errors.current_location ? (
                  <div className={styles.error}>
                    {formik.errors.current_location}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box className={styles.icon_style} style={{ left: "7px" }}>
                    <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                  </Box>

                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={locations?.data?.locations || []}
                    disableCloseOnSelect
                    value={
                      locations?.data?.locations?.filter((location) =>
                        formik.values.prefer_location?.includes(location.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedLocations = value?.map(
                        (location) => location?.id
                      );
                      formik.setFieldValue(
                        "prefer_location",
                        selectedLocations
                      );
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>{" "}
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Preferred Location"
                        variant="standard"
                        size="small"
                        name="prefer_location"
                        sx={fieldStyle}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                </Box>
                {formik.touched.prefer_location &&
                formik.errors.prefer_location ? (
                  <div className={styles.error}>
                    {formik.errors.prefer_location}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingsLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Work Preference"
                  sx={fieldStyle}
                  name="work_preference"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_preference}
                  select
                  variant="standard"
                >
                  {work.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_preference &&
                formik.errors.work_preference ? (
                  <div className={styles.error}>
                    {formik.errors.work_preference}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiInvoiceLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  label="Rate"
                  sx={fieldStyle}
                  name="rate"
                  type="text"
                  // onChange={handleChnageRate}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                    // formik.setFieldValue("rate", rawValue);
                    if (rawValue.length <= 3) {
                      formik.setFieldValue("rate", rawValue); // Set value only if length <= 3
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={
                    formik.values.rate ? `$${formik.values.rate} Hourly` : ""
                  }
                  // value={formik.values.rate}
                  variant="standard"
                ></TextField>
                {formik.touched.rate && formik.errors.rate ? (
                  <div className={styles.error}>{formik.errors.rate}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBookOpenUserLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  label="Qualification"
                  variant="standard"
                  sx={fieldStyle}
                  name="highest_qualification"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.highest_qualification}
                ></TextField>
                {formik.touched.highest_qualification &&
                formik.errors.highest_qualification ? (
                  <div className={styles.error}>
                    {formik.errors.highest_qualification}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingsLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="University"
                  variant="standard"
                  type="text"
                  sx={fieldStyle}
                  name="university"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.university}
                />
                {formik.touched.university && formik.errors.university ? (
                  <div className={styles.error}>{formik.errors.university}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingsLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Passing year"
                  variant="standard"
                  type="number"
                  name="passing_year"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.passing_year}
                  sx={fieldStyle}
                />
                {formik.touched.passing_year && formik.errors.passing_year ? (
                  <div className={styles.error}>
                    {formik.errors.passing_year}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiLinkedin style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="LinkedIn URL (Optional)"
                  variant="standard"
                  type="text"
                  sx={fieldStyle}
                  name="linkedin_profile_url"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.linkedin_profile_url}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box className={styles.icon_style} style={{ left: "7px" }}>
                    <IoBookOutline style={{ fontSize: "22px" }} />
                  </Box>

                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={skillData?.locations || []}
                    disableCloseOnSelect
                    value={
                      skillData?.locations?.filter((skl) =>
                        formik.values.skills?.includes(skl.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedLocations = value?.map((skl) => skl?.id);
                      formik.setFieldValue("skills", selectedLocations);

                      // ✅ Reset addedSkill when manually removing skills
                      if (selectedLocations.length === 0) {
                        handleClearAll(); // Call clear all method
                      } else {
                        dispatch(resetAddedSkill());
                      }
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    inputValue={inputText}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setInputText(newInputValue);
                      }
                    }}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>
                      </MenuItem>
                    )}
                    ListboxComponent={renderVirtualizedList} // Use virtualized list
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Skills (Optional)"
                        variant="standard"
                        size="small"
                        name="skills"
                        sx={fieldStyle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddSkill();
                          }
                        }}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                </Box>
                {formik.touched.skills && formik.errors.skills ? (
                  <div className={styles.error}>{formik.errors.skills}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box className={styles.icon_style} style={{ left: "7px" }}>
                    <IoBookOutline style={{ fontSize: "22px" }} />
                  </Box>
                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={skillData?.locations || []}
                    disableCloseOnSelect
                    value={
                      skillData?.locations?.filter((skl) =>
                        formik.values.secondary_skills?.includes(skl.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedLocations = value?.map((skl) => skl?.id);
                      formik.setFieldValue(
                        "secondary_skills",
                        selectedLocations
                      );

                      // ✅ Reset addedSkill when manually removing skills
                      if (selectedLocations.length === 0) {
                        handleClearAllSecondarySkill(); // Call clear all method
                      } else {
                        dispatch(resetAddedSkill());
                      }
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    inputValue={inputTextSecondary}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setInputTextSecondary(newInputValue);
                      }
                    }}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>
                      </MenuItem>
                    )}
                    ListboxComponent={renderVirtualizedList} // Use virtualized list
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Secondary Skills (Optional)"
                        variant="standard"
                        size="small"
                        name="secondary_skills"
                        sx={fieldStyle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddSkillSecondary();
                          }
                        }}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                </Box>
                {formik.touched.secondary_skills &&
                formik.errors.secondary_skills ? (
                  <div className={styles.error}>
                    {formik.errors.secondary_skills}
                  </div>
                ) : null}
              </Grid>
            </Grid>

            {formFields?.map((field, index) => (
              <form onSubmit={(e) => e.preventDefault()} key={index}>
                <Grid
                  container
                  key={index}
                  className={styles.candidate_field_section}
                  sx={{ backgroundColor: "#fff" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiUserLight style={{ fontSize: "25px" }} />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Role"
                      variant="standard"
                      name="role"
                      sx={fieldStyle}
                      value={field.role}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box
                      className={styles.icon_style}
                      sx={{ transform: "translateY(-50%) !important" }}
                    >
                      <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Organization"
                      variant="standard"
                      type="text"
                      name="company"
                      sx={fieldStyle}
                      value={field.company}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Domain"
                      variant="standard"
                      type="text"
                      name="industry_of_the_company"
                      sx={fieldStyle}
                      value={field.industry_of_the_company}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Duration From"
                      variant="standard"
                      type="text"
                      name="duration_from"
                      sx={fieldStyle}
                      value={field.duration_from}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Grid>
                  {index !== 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Duration To"
                        variant="standard"
                        type="text"
                        name="duration_to"
                        sx={fieldStyle}
                        value={field.duration_to}
                        onChange={(event) => handleInputChange(index, event)}
                      />
                    </Grid>
                  )}
                </Grid>

                <Box
                  className={styles.add_section}
                  sx={{ display: "block !important" }}
                >
                  <Box>
                    <Typography>
                      <b> Responsibilities</b>{" "}
                    </Typography>

                    <Typography sx={{ marginBottom: "0 !important" }}>
                      <textarea
                        className="form-control"
                        rows="2"
                        name="summary_of_work"
                        value={field.summary_of_work}
                        onChange={(event) => {
                          handleInputChange(index, event);
                          autoResize(event.target);
                        }}
                        onInput={(event) => autoResize(event.target)}
                        style={{
                          width: "100%", // Make it take full width of the parent container
                          borderColor: "#1991e0",
                          overflow: "hidden",
                          resize: "none", // Prevent manual resizing
                        }}
                        ref={(el) => el && autoResize(el)} // Auto-resize on initial render
                      ></textarea>

                      {formFields?.length - 1 === index && (
                        <Link
                          className={styles.view_show_link}
                          onClick={handleToggle}
                        >
                          <IoIosAdd
                            onClick={handleAddFields}
                            style={{
                              marginTop: "10px",
                              fontSize: "30px",
                              color: "#000",
                              backgroundColor: "#f2f2f2",
                              borderRadius: "3px",
                              marginLeft: "20px",
                              float: "right",
                            }}
                          />
                        </Link>
                      )}
                    </Typography>
                  </Box>
                </Box>

                <Grid
                  item
                  xs={12}
                  md={0.6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "0 !important",
                  }}
                ></Grid>
              </form>
            ))}

            {(formik?.values?.prefer_tax_team?.includes("contract") ||
              formik?.values?.prefer_tax_team?.includes(
                "contract_to_hire"
              )) && (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiBuildingOfficeLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Company Name"
                    variant="standard"
                    sx={fieldStyle}
                    name="referrer_company_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.referrer_company_name}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiUserLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Manager’s Name"
                    variant="standard"
                    type="text"
                    sx={fieldStyle}
                    name="referrer_manager_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.referrer_manager_name}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiMailboxLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Work Phone No"
                    variant="standard"
                    type="text"
                    sx={fieldStyle}
                    name="referrer_mobile_no"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.referrer_mobile_no}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Work E-Mail ID"
                    variant="standard"
                    type="text"
                    sx={fieldStyle}
                    name="referrer_email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.referrer_email}
                  />
                </Grid>
              </Grid>
            )}
            {(formik?.values?.prefer_tax_team?.includes("contract") ||
              formik?.values?.prefer_tax_team?.includes(
                "contract_to_hire"
              )) && (
              <Box
                className={styles.employer_details}
                sx={{ backgroundColor: "#dae3f2" }}
              >
                <Typography sx={{ color: customTextColor }}>
                  Employer’s Details
                </Typography>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiUserLight
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Employer’s Name"
                      variant="standard"
                      name="referrer_manager_name2"
                      onChange={handleEmployerFullNameChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.referrer_manager_name2}
                      sx={fieldStyle}
                    />
                    {formik.touched.referrer_manager_name2 &&
                      formik.errors.referrer_manager_name2 && (
                        <div className={styles.error}>
                          {formik.errors.referrer_manager_name2}
                        </div>
                      )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiBuildingOfficeLight
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Company Name"
                      variant="standard"
                      type="text"
                      name="referrer_company_name2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.referrer_company_name2}
                      sx={fieldStyle}
                    />
                    {formik.touched.referrer_company_name2 &&
                      formik.errors.referrer_company_name2 && (
                        <div className={styles.error}>
                          {formik.errors.referrer_company_name2}
                        </div>
                      )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Email ID"
                      variant="standard"
                      type="text"
                      name="referrer_email2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.referrer_email2}
                      sx={fieldStyle}
                    />
                    {formik.touched.referrer_email2 &&
                      formik.errors.referrer_email2 && (
                        <div className={styles.error}>
                          {formik.errors.referrer_email2}
                        </div>
                      )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Phone No"
                      variant="standard"
                      type="text"
                      name="referrer_mobile_no2"
                      onChange={handleEmployerMobileNoChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.referrer_mobile_no2}
                      sx={fieldStyle}
                    />
                    {formik.touched.referrer_mobile_no2 &&
                      formik.errors.referrer_mobile_no2 && (
                        <div className={styles.error}>
                          {formik.errors.referrer_mobile_no2}
                        </div>
                      )}
                  </Grid>
                </Grid>
              </Box>
            )}
          </form>
          <Box className={styles.add_consultant_btns}>
            <button
              onClick={handleClose}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4px 15px ",
                color: "#fff",
              }}
              disabled={candidateStatus === "loading"}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#fff" }}
              />
            </button>
            <button
              style={{ padding: "7px 15px" }}
              onClick={formik.handleSubmit}
              disabled={candidateStatus === "loading"}
            >
              {candidateStatus === "loading"
                ? "Loading"
                : candidateType === "edit"
                ? "Update"
                : "Submit"}
            </button>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCandidateDrawer;
